<template>
  <div class="vx-card" id="stockTransact">
    <div class="vx-row vx-body">
      <div class="vx-col w-1/2">
        <stock-list @selectedProduct="selectedProduct" :productDataForAggrid="allProducts"></stock-list>
      </div>
      <div class="vx-col w-1/2">
        <counted-stock v-model="tempList" @save="itemsForSave"></counted-stock>
      </div>
    </div>

    <selected-product-view
      :displaySelected="displaySelected"
      v-if="displaySelected"
      v-model="selectedItem"
      @closeSelected="hideSelected"
      @quantitiy="transporter"
    ></selected-product-view>

    <inventory-report
      :differences="diffChecker"
      :inventoryList="tempList"
      :displayInv="displayInventoryReport"
      @closePage="hideDisplayInventoryReport"
      v-if="displayInventoryReport"
    ></inventory-report>
  </div>
</template>
<script>
import stockList from "./stockList.vue";
import countedStock from "./countedStock.vue";
import selectedProductView from "./selectedProductView.vue";
import inventoryReport from "./inventoryReport.vue";
import { repository } from "@/_services/repository.js";

export default {
  components: {
    stockList,
    countedStock,
    selectedProductView,
    inventoryReport,
  },
  data() {
    return {
      allProducts: [],
      tempList: [],
      displaySelected: false,
      displayInventoryReport: false,
      selectedItem: {},
      diffChecker: [],
    };
  },
  methods: {
    itemsForSave() {
      this.diffChecker.splice(0, this.diffChecker.length);
      for (let i = 0; i < this.tempList.length; i++) {
        this.allProducts.find((x) => {
          if (
            x.productId == this.tempList[i].productId &&
            x.stock != this.tempList[i].quantity
          )
            this.diffChecker.push({
              productId: x.productId,
              productName: x.productName,
              barcodeList: x.barcodeList,
              stock: x.stock,
              newStock: this.tempList[i].quantity,
            });
        });
      }
      this.displayInventoryReport = true;
    },
    hideDisplayInventoryReport() {
      this.displayInventoryReport = false;
    },
    selectedProduct(val) {
      this.displaySelected = true;
      this.selectedItem = val;
    },
    hideSelected() {
      this.displaySelected = false;
    },
    //"quantitiy", this.value , q , false
    transporter(val, qty, bar) {
      if (!bar) {
        this.addItem(val.productId, val.productName, null, qty);
      } else {
        this.addItem(val.productId, val.productName, qty, 1);
      }
    },
    addItem: function (productId, productName, barcode, quantity) {
      let product = this.tempList.find((x) => x.productId == productId);

      if (product) {
        if (barcode && barcode.length > 0) {
          let exist = false;
          for (let i = 0; i < product.barcodeList.length; i++) {
            if (product.barcodeList[i] == barcode) {
              exist = true;
              break;
            }
          }
          if (exist) {
            this.$vs.notify({
              title: "Hata",
              text: barcode + " serinolu ürün daha önce eklenmiş!",
              color: "danger",
              icon: "warning",
            });
            return;
          }
          product.barcodeList.push(barcode);
          product.quantity++;
        } else {
          product.quantity += quantity;
        }
      } else {
        if (barcode && barcode.toString().length > 0) {
          this.tempList.unshift({
            productId: productId,
            barcodeList: [barcode.toString()],
            productName: productName,
            quantity: 1,
          });
        } else {
          this.tempList.unshift({
            productId: productId,
            barcodeList: null,
            productName: productName,
            quantity: quantity,
          });
        }
      }
    },
    getProducts: async function () {
      let data = await repository.getAll("Product/getProductsV2");
      if (data && data.isSuccessful) {
        data = data.list;
        data = repository.convertToJSON(data, "stock");
        for (let i = 0; i < data.length; i++) {
          if (data[i].stock) {
            let found = false;
            for (let j = 0; j < data[i].stock.length; j++) {
              if (data[i].stock[j].isManager) {
                found = true;
                data[i].stock = data[i].stock[j].Stock;
                break;
              }
            }
            if (!found) data[i].stock = 0;
          } else data[i].stock = 0;
        }
      } else {
        this.$vs.notify({
          title: "Hata",
          text: "Ürünler listesine erişilemedi",
          color: "danger",
        });
        return;
      }
      this.allProducts = data;
    },
  },
  created() {
    this.getProducts();
    let remain = JSON.parse(localStorage.getItem("inventoryReport"));
    if (remain) {
      this.tempList = JSON.parse(localStorage.getItem("inventoryReport"));
    }
  },
  mounted() {
    this.$vs.dialog({
      title: "Uyarı",
      text: "Yapacağınız işlemler stokları değiştirecektir !",
      color: "warning",
      acceptText: "Kabul Et",
    });
  },
  watch: {
    tempList: function () {
      localStorage.setItem("inventoryReport", JSON.stringify(this.tempList));
    },
  },
};
</script>
<style lang="scss" scoped>
#stockTransact {
  .centered {
    text-align: center;
  }
  span {
    font-size: 13px;
  }
  b {
    font-size: 15px;
  }
  .vx-card {
    width: 100%;
    height: 80vh;
  }
  .vs-con-tbody {
    height: calc(80vh - 100px);
    td {
      overflow: hidden;
    }
  }
  .vx-header {
    background: rgb(211, 211, 211);
    height: 50px;
    width: 100%;
    padding: 15px;
  }
  .vx-body {
    height: calc(78vh);
    margin-left: 5px;
    margin-right: 5px;
  }
  .vx-footer {
    height: 50px;
    width: 100%;
    padding: 10px;
  }
}
</style>